module.exports = __webpack_public_path__ + "static/img/Rectangle 60 (2).447d9f77.png";